import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
export const styles = (theme: Theme) => {
	return ({
		textField: {backgroundColor: "#fff", paddingRight: 56},
		endAdornment: { right: 8 },
		focused: {
			"& fieldset": {
				borderWidth: 2
			}
		},
	} satisfies Record<string, CSSObject>);
};
